export enum BellNotificationType {
  EXTERNAL_ORDER_UPDATE = 'external_order_update',
}

export enum BellNotificationAction {
  OTHER = 'other',
  STATUS_UPDATED = 'status_updated',
  SUBMISSION_FAILED = 'submission_failed',
}

// DEFAULT completes the toast's Alert set; no handler emits it yet.
export enum BellNotificationSeverity {
  DEFAULT = 'default',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}

// The drawer's tabs; Unread lists through the list endpoint's unread_only filter.
export enum BellNotificationListFilter {
  ALL = 'all',
  UNREAD = 'unread',
}

// Where a notification renders: the drawer row and the toast style their buttons differently.
export enum BellNotificationSurface {
  DRAWER = 'drawer',
  TOAST = 'toast',
}
